import { Component } from '@angular/core';
import { JeevesCustomerListCardComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'car-liner-customer-list-card',
    templateUrl: './car-liner-customer-list-card.component.html',
    styleUrl: './car-liner-customer-list-card.component.scss',
    standalone: false
})
export class CarLinerCustomerListCardComponent extends JeevesCustomerListCardComponent {

}
